export function Caret() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
      <path fill="#ececf7" d="M8 4.8l3.6 4H4.4z" />
    </svg>
  );
}
